
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/formula1-racing/teams",
      function () {
        return require("private-next-pages/formula1-racing/teams/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/formula1-racing/teams"])
      });
    }
  